import React, { useCallback, useMemo } from 'react'
import { Modal } from 'antd'
import { IFormData, NotAcceptedModalProps } from './interfaces'
import { DefaultJsonForm } from '../../../../../../components/v2/default-json-form'
import schemaJson from './schema.json'
import { convertData2JsonForm } from '../../../../../../shared/lib/convertData2JsonForm'

const ModalNotAccepted: React.FC<NotAcceptedModalProps> = (props: NotAcceptedModalProps) => {
  const { onOk, isOpen, onCancel } = props
  const [formData, setFormData] = React.useState<IFormData>({
    disagreement_act: undefined,
  })

  const schema = useMemo(() => {
    return convertData2JsonForm(schemaJson).resultSchema
  }, [schemaJson])

  const handleCloseModal = () => {
    onCancel?.()
  }

  const handleOk = useCallback(() => {
    if (!formData.disagreement_act) {
      Modal.warning({
        title: 'Предупреждение',
        content: 'Заполните все обязательные поля',
      })
      return
    }
    onOk?.({ disagreement_act: formData.disagreement_act })
  }, [formData])

  const handleChange = useCallback(
    data => {
      setFormData(prevData => ({ ...prevData, ...data }))
    },
    [formData],
  )

  return (
    <>
      <Modal title="Монтаж не принят" open={isOpen} onCancel={handleCloseModal} onOk={handleOk}>
        <DefaultJsonForm
          formData={formData}
          schema={schema}
          onChange={handleChange}
          orientation="horizontal"
        />
      </Modal>
    </>
  )
}

export default ModalNotAccepted
